import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import type { Workbook, Worksheet } from '@/types/workbook';

export const useFetchWorkbookData = (url: string) => {
  const query = useQuery({
    queryKey: ['fetch-workbook-data', url],
    queryFn: () => {
      return axios.get<Workbook>(url)
        .then(res => {
          return transformResponse(res.data);
        });
    },
  });

  return query;
};

function transformResponse(data: Workbook) {
  return {
    sheets: data.sheets.map(transformSheet),
  };
}

function transformSheet(sheet: Worksheet): Worksheet {
  return {
    ...sheet,
    columns: sheet.columns.length < 6
      ? ['A', 'B', 'C', 'D', 'E', 'F']
      : sheet.columns,
    rows: Math.max(sheet.rows, 30),
  };
}

export default useFetchWorkbookData;